import { Component, INJECTOR, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { OtherRegistrationComponent } from '../other-registration/other-registration.component';
import { DialogRef } from '@angular/cdk/dialog';
import { LoginComponent } from '../login/login.component';
import { InternationalauthService } from 'src/app/_service/internationalauth.service';

@Component({
  selector: 'app-other-auth',
  templateUrl: './other-auth.component.html',
  styleUrls: ['./other-auth.component.css']
})
export class OtherAuthComponent implements OnInit {

  intFormGroup:FormGroup;
  termsAndConditionsError: boolean = false;
  @Input() selectedCountry: string;
  @Input() deviceId: string;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private dialogRef: DialogRef<LoginComponent>,
    private internationalAuth: InternationalauthService
  ) {
    this.intFormGroup = this.fb.group({
      userName: [
        '@', 
        [Validators.required, Validators.minLength(5), Validators.maxLength(20), this.alphanumericValidator] // Note: This is the correct 'validators' array.
      ],
      pin: this.fb.array(
        new Array(4).fill('').map(() => this.fb.control('', [Validators.required, Validators.pattern('[0-9]')])),
        Validators.required
      ),
      tcAgree: [false, [Validators.requiredTrue]]
    });
   }

  ngOnInit(): void {

  }

  onSubmit(){
    if (this.intFormGroup.valid) {
      this.termsAndConditionsError = false;
      const requestBody = {
        'username': this.intFormGroup.get('userName')?.value,
        'pin': this.pinArray.value.join(''),
        'deviceId': this.deviceId,
        'deviceType': 'WEB',
        'fbTokenId': ''
      }
      this.internationalAuth.internationalSignIn(requestBody).subscribe((result)=>{
        console.log(result);
        if(result){
          // this.dialogRef.close();
          window.location.reload();
        }else{
          alert('User not found');
        }
      })
      console.log('User Handle:', requestBody.username);
      console.log('PIN:', requestBody.pin); 
      console.log('Accepted Terms:', requestBody.deviceId);
      console.log('Login Successful', this.selectedCountry);
    } else {
      this.termsAndConditionsError = !this.intFormGroup.get('tcAgree')?.value;

      this.intFormGroup.markAllAsTouched();
    }
  }

  alphanumericValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value.substring(1); 

    const hasAlphabet = /[a-zA-Z]/.test(value); 
    const hasNumber = /\d/.test(value); 

    if (!hasAlphabet || !hasNumber) {
      return { alphanumeric: true }; 
    }
    return null; 
  }

  get pinArray() {
    return this.intFormGroup.get('pin') as FormArray;
  }

  onUserHandlerInput(event: KeyboardEvent){
    const input = event.target as HTMLInputElement;

    if(input.selectionStart === 0){
      event.preventDefault();
      input.setSelectionRange(1,1);
    }

    if(!input.value.startsWith('@')){
      input.value = '@' + input.value.replace('@', '');
      this.intFormGroup.get('userHandler')?.setValue(input.value);
    }
  }

  openTermsDialog(url: string) {
    window.open(url, '_blank');
  }

  getOtpDigits(): string[] {
    return Array.from({ length: 6 }, (_, i) => i.toString());
  }

  hasPinError(error: string): boolean {
    return this.pinArray.controls.some(ctrl => ctrl.touched && ctrl.hasError(error));
  }

  onInput(event: any, index: number): void {
    const inputValue = event.target.value;
    if (inputValue && index < 5) {
      const nextInput = document.getElementById(`otp${index + 1}`) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
  }
  
  onKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      if (index > 0) {
        const prevInput = document.getElementById(`otp${index - 1}`) as HTMLInputElement;
        if (prevInput) {
          prevInput.focus();
        }
      }
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      if (index < 5) {
        const nextInput = document.getElementById(`otp${index + 1}`) as HTMLInputElement;
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  }
  
  onInputKeyUp(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      event.preventDefault();
      if (index > 0) {
        const currentInput = document.getElementById(`otp${index}`) as HTMLInputElement;
        if (currentInput) {
          currentInput.value = '';
          const prevInput = document.getElementById(`otp${index - 1}`) as HTMLInputElement;
          if (prevInput) {
            prevInput.focus();
          }
        }
      }
    } else {
      const inputValue = (event.target as HTMLInputElement).value;
      if (!/^\d$/.test(inputValue)) {
        event.preventDefault();
      }
    }
  }

  showPassword:boolean;
  togglePassword(){
    this.showPassword = !this.showPassword;
  }

  openRegistration(){
    this.dialogRef.close();
    const dialogRef = this.dialog.open(OtherRegistrationComponent, {
      height:'90vh',
      panelClass: 'custom-dialog-container'
    })
  }
}
